import React from 'react';

export type LabelProps = {
	required?: boolean;
	text: string;
} & React.InputHTMLAttributes<HTMLLabelElement>;

export default function Label({ required, text, ...props }: LabelProps) {
	return (
		<label
			className={`custom-form-label ${required ? 'label-required' : ''}`}
			{...props}
		>
			{text}
		</label>
	);
}
